/* eslint-disable @typescript-eslint/naming-convention */

import { SlideResponseType } from "../../../_types"

export const _mockSlideResponse_0: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-001.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 1,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_1: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-002.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 2,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_2: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-003.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 3,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_3: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-004.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 4,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_4: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-005.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 5,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_5: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-006.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 6,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_6: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-007.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 7,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_7: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-008.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 8,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_8: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-009.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 9,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_9: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-010.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 10,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_10: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-011.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 11,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_11: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-012.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 12,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}
export const _mockSlideResponse_12: SlideResponseType = {
  id: 2921,
  presentationID: 135,
  status: 10,
  fileName: "Slide-013.png",
  caption: 0,
  audio: 0,
  time: 0,
  timeRelative: 1,
  number: 13,
  createdAt: "2022-11-23 17:06:38",
  updatedAt: "2017-04-17 12:01:14",
}

export const _mockSlidesResponse_0: SlideResponseType[] = [
  _mockSlideResponse_0,
  _mockSlideResponse_1,
  _mockSlideResponse_2,
  _mockSlideResponse_3,
  _mockSlideResponse_4,
  _mockSlideResponse_5,
  _mockSlideResponse_6,
  _mockSlideResponse_7,
  _mockSlideResponse_8,
  _mockSlideResponse_9,
  _mockSlideResponse_10,
  _mockSlideResponse_11,
  _mockSlideResponse_12,
]
export const _mockSlidesResponse_1: SlideResponseType[] = [
  _mockSlideResponse_0,
  _mockSlideResponse_1,
  _mockSlideResponse_2,
  _mockSlideResponse_3,
  _mockSlideResponse_4,
  _mockSlideResponse_5,
  _mockSlideResponse_6,
  _mockSlideResponse_7,
]
